import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import LinkedInIcon from '@material-ui/icons/LinkedIn';
import GitHubIcon from '@material-ui/icons/GitHub';
import CareerLine from '../components/CareerLine';
import Link from '@material-ui/core/Link';
import EmailIcon from '@material-ui/icons/Email';
import AccountBoxIcon from '@material-ui/icons/AccountBox';
import Avatar from '@material-ui/core/Avatar';

const useStyles = makeStyles((theme) => ({
  panel: {
    margin: 50,
    display: "flex",
    flexDirection: "column",
  },
  info: {
    display: "flex",
    justifyContent: "center",
  },
  ava: {
    marginRight: 10,
  },
  link: {
    display: "flex",
    justifyContent: "center",
  },
  icon: {
    fontSize: 40,
    margin: 10,
  }
}));
export default function Me() {
  const classes = useStyles();
  return (
    <Box color="text.primary" className={classes.panel}>
      <div className={classes.info}>
        <Avatar alt="Jianhang Yin" src="/imgs/me.png" className={classes.ava}/>
        <Typography 
          variant="h4"
        >
          Jianhang Yin
        </Typography>
      </div>
      <Typography 
        className={classes.info}
        style={{ marginTop: 20 }}
      >
        Software Engineer at Google
      </Typography>
      <CareerLine />
      <Typography style={{ fontSize: 30, textAlign: "center" }}>contact</Typography>
      <Box className={classes.link}>
        <Link href="https://www.linkedin.com/in/jianhang-yin-370197182/" target="_blank"><LinkedInIcon className={classes.icon}/></Link>
        <Link href="https://github.com/JianhangYin" target="_blank"><GitHubIcon className={classes.icon} /></Link>
        <Link href="mailto: jianhang@usc.edu" target="_blank"><EmailIcon className={classes.icon} /></Link>
        <Link href={process.env.PUBLIC_URL + '/pdf/Jianhang_2021_Resume.pdf'} target="_blank"><AccountBoxIcon className={classes.icon} /></Link>
      </Box>
    </Box>
  );
}